import React from 'react';

/**
 * TargetGroup — three target-group profiles. Auto-numbered when rendered
 * inside a `.numbered-sections` ancestor.
 */
export default function TargetGroup() {
  const profiles = [
    {
      n: '01',
      title: 'Privatinvestoren',
      detail:
        'Eigentümer ab einem Mehrfamilienhaus, die wissen, dass ihr Objekt mehr kann.',
    },
    {
      n: '02',
      title: 'Familien im Generationswechsel',
      detail:
        'Sie haben das Portfolio von Ihren Eltern übernommen oder bauen es für Ihre Kinder auf.',
    },
    {
      n: '03',
      title: 'Treuhänder und Dritte',
      detail:
        'Drittparteien, die Wohnbestand im Rhein-Main-Gebiet betreuen und die operative Verantwortung optimal abgeben wollen.',
    },
  ];

  return (
    <section style={{ padding: '120px 0' }}>
      <div className="shell">
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(220px, 280px) 1fr', gap: 64, alignItems: 'start' }}>
          <div className="reveal">
            <div className="section-label numbered" style={{ marginBottom: 28 }}>
              <span>Unsere Kunden</span>
            </div>
            <h2 className="h-section" style={{ fontSize: 'clamp(32px, 3.4vw, 44px)' }}>
              Mit wem wir arbeiten.
            </h2>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              gap: 0,
              borderTop: '1px solid var(--cream-line)',
            }}
          >
            {profiles.map((p, i) => (
              <div
                key={i}
                className="reveal"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '80px 1fr',
                  gap: 32,
                  alignItems: 'start',
                  padding: '32px 0',
                  borderBottom: '1px solid var(--cream-line)',
                }}
              >
                <div
                  style={{
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                    fontSize: 12,
                    letterSpacing: '0.1em',
                    color: 'var(--charcoal-muted)',
                    paddingTop: 6,
                  }}
                >
                  {p.n}
                </div>
                <div>
                  <h3 className="h-pillar" style={{ fontSize: 22, marginBottom: 10, lineHeight: 1.25 }}>
                    {p.title}
                  </h3>
                  <p className="body-prose" style={{ color: 'var(--charcoal-muted)', fontSize: 16 }}>
                    {p.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
